import api from '../api/axios';

export function docxFilename(programmeName, moduleName) {
  const programme = String(programmeName || 'document').replace(/[^a-z0-9]/gi, '_') || 'document';
  const modulePart = String(moduleName || 'content').replace(/[^a-z0-9]/gi, '_') || 'content';
  return `${programme}-${modulePart}.docx`;
}

async function exportErrorMessage(error) {
  const data = error?.response?.data;
  if (typeof Blob !== 'undefined' && data instanceof Blob) {
    const text = await data.text().catch(() => '');
    if (!text) return error.message || 'Word export failed';
    try {
      const json = JSON.parse(text);
      return json.message || json.error || text;
    } catch {
      return text;
    }
  }
  return error?.response?.data?.message || error?.message || 'Word export failed';
}

export async function downloadDocx({ programmeName, moduleName, contentHtml }) {
  try {
    const response = await api.post('/docx/export', {
      programmeName,
      moduleName,
      contentHtml
    }, { responseType: 'blob' });
    const blob = response.data;
    if (!blob || blob.size === 0) {
      throw new Error('Word export returned an empty file');
    }
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = docxFilename(programmeName, moduleName);
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    if (error?.response) {
      throw new Error(await exportErrorMessage(error));
    }
    throw error;
  }
}
